export default "__VITE_ASSET__BpwvJNCU__"